// var atob = require('atob')

const apiKey = 'niCFvC6PDJ6LZsCQL7I3F8deM3Wsw4IV7GSKZhpg';

const apiClient ={
  
  createQuestionnaire:async (questionnaire)=> {
    // console.log("lead: ", lead)
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'x-api-key': 'niCFvC6PDJ6LZsCQL7I3F8deM3Wsw4IV7GSKZhpg' },
          body: JSON.stringify(questionnaire)
      };
      const response = await fetch(`https://tcmrzmikw7.execute-api.eu-west-1.amazonaws.com/PROD/createQuestionnaire`, requestOptions);
    return await response.json();
      }
  }

export default apiClient;


// POST - https://75gdr604jg.execute-api.us-east-1.amazonaws.com/v1/

// DjXS8CyISZ7MZBL4B58Nr5e4r6o7jU7tarBvbIR1
